// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_cabinet__KassaSubheader from "../../components/molecules/OrgDashboardHeader/KassaSubheader.js";
import * as Buhta_cabinet__KkmSettingsConnection from "../../components/organisms/Kassa/KKM/KkmSettingsConnection.js";
import * as Buhta_cabinet__KkmSettingsEtp from "../../components/organisms/Kassa/KKM/KkmSettingsEtp.js";
import * as Buhta_cabinet__KkmSettingsGeneral from "../../components/organisms/Kassa/KKM/KkmSettingsGeneral.js";
import * as Buhta_cabinet__KkmSettingsOfd from "../../components/organisms/Kassa/KKM/KkmSettingsOfd.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__LoadingDiv from "../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (id) {
    return function (tab) {
      return function (openMenu) {
        const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
        const deviceType = state.deviceType;
        const match = Buhta_core__Tenant.useTenant(undefined);
        const tenant = match[0];
        const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
        const contextRoute = function (route) {
          return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
        };
        const func = Buhta_cabinet__Kassa.KkmManagerService.view;
        const match$1 = Buhta_core__GrpcState.useModel((function (param) {
                return Curry._3(func, param, {
                            hd: "preferences",
                            tl: /* [] */0
                          }, id);
              }), undefined);
        const dispatch = match$1[1];
        const kkmObj = match$1[0];
        React.useEffect((function () {
                Curry._2(dispatch, undefined, undefined);
              }), [id]);
        const backButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
              route: contextRoute({
                    TAG: /* Kassa */2,
                    _0: /* Kkms */{
                      _0: /* List */1
                    }
                  }),
              children: JsxRuntime.jsx("img", {
                    className: "w-5 h-5",
                    src: StaticAsset.src("/static/icons/back-arrow.svg")
                  })
            });
        const subheader = typeof kkmObj === "string" || kkmObj.NAME !== "Data" ? null : JsxRuntime.jsx(Buhta_cabinet__KassaSubheader.make, {
                currentRoute: currentRoute,
                kkm: kkmObj.VAL,
                contextRoute: contextRoute
              });
        const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
                title: typeof kkmObj === "string" || kkmObj.NAME !== "Data" ? "Касса" : kkmObj.VAL.name,
                leftChildren: backButton,
                openMenu: openMenu,
                subheader: subheader
              }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
                title: "Настройки"
              });
        let tmp;
        if (typeof kkmObj === "string") {
          tmp = kkmObj === "Loading" ? JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
        } else if (kkmObj.NAME === "Data") {
          const kkm = kkmObj.VAL;
          let tmp$1;
          switch (tab) {
            case /* General */0 :
                tmp$1 = JsxRuntime.jsx(Buhta_cabinet__KkmSettingsGeneral.make, {
                      kkm: kkm
                    });
                break;
            case /* Etp */1 :
                tmp$1 = JsxRuntime.jsx(Buhta_cabinet__KkmSettingsEtp.make, {
                      id: id
                    });
                break;
            case /* Connection */2 :
                tmp$1 = JsxRuntime.jsx(Buhta_cabinet__KkmSettingsConnection.make, {
                      kkm: kkm
                    });
                break;
            case /* Ofd */3 :
                tmp$1 = JsxRuntime.jsx(Buhta_cabinet__KkmSettingsOfd.make, {
                      kkm: kkm,
                      org: org
                    });
                break;
            
          }
          tmp = JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                route: contextRoute({
                                      TAG: /* Kassa */2,
                                      _0: /* Kkms */{
                                        _0: /* Kkm */{
                                          _0: id,
                                          _1: {
                                            TAG: /* Settings */0,
                                            _0: /* General */0
                                          }
                                        }
                                      }
                                    }),
                                className: Cn.fromList({
                                      hd: "py-2.5 grow lg:grow-0",
                                      tl: {
                                        hd: Cn.on("border-b border-links", tab === /* General */0),
                                        tl: /* [] */0
                                      }
                                    }),
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: Cn.fromList({
                                            hd: "text-center",
                                            tl: {
                                              hd: tab === /* General */0 ? "text-links" : "text-gray-medium",
                                              tl: /* [] */0
                                            }
                                          }),
                                      children: "Общие данные"
                                    })
                              }),
                          kkm.ofd_provider_id === 1 ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                  route: contextRoute({
                                        TAG: /* Kassa */2,
                                        _0: /* Kkms */{
                                          _0: /* Kkm */{
                                            _0: id,
                                            _1: {
                                              TAG: /* Settings */0,
                                              _0: /* Ofd */3
                                            }
                                          }
                                        }
                                      }),
                                  className: Cn.fromList({
                                        hd: "py-2.5 grow lg:grow-0",
                                        tl: {
                                          hd: Cn.on("border-b border-links", tab === /* Ofd */3),
                                          tl: /* [] */0
                                        }
                                      }),
                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: Cn.fromList({
                                              hd: "text-center",
                                              tl: {
                                                hd: tab === /* Ofd */3 ? "text-links" : "text-gray-medium",
                                                tl: /* [] */0
                                              }
                                            }),
                                        children: "ОФД"
                                      })
                                }) : null,
                          JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                route: contextRoute({
                                      TAG: /* Kassa */2,
                                      _0: /* Kkms */{
                                        _0: /* Kkm */{
                                          _0: id,
                                          _1: {
                                            TAG: /* Settings */0,
                                            _0: /* Etp */1
                                          }
                                        }
                                      }
                                    }),
                                className: Cn.fromList({
                                      hd: "py-2.5 grow lg:grow-0",
                                      tl: {
                                        hd: Cn.on("border-b border-links", tab === /* Etp */1),
                                        tl: /* [] */0
                                      }
                                    }),
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: Cn.fromList({
                                            hd: "text-center",
                                            tl: {
                                              hd: tab === /* Etp */1 ? "text-links" : "text-gray-medium",
                                              tl: /* [] */0
                                            }
                                          }),
                                      children: "ЭТП"
                                    })
                              }),
                          kkm.ofd_provider_id !== 1 ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                  route: contextRoute({
                                        TAG: /* Kassa */2,
                                        _0: /* Kkms */{
                                          _0: /* Kkm */{
                                            _0: id,
                                            _1: {
                                              TAG: /* Settings */0,
                                              _0: /* Connection */2
                                            }
                                          }
                                        }
                                      }),
                                  className: Cn.fromList({
                                        hd: "py-2.5 grow lg:grow-0",
                                        tl: {
                                          hd: Cn.on("border-b border-links", tab === /* Connection */2),
                                          tl: /* [] */0
                                        }
                                      }),
                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: Cn.fromList({
                                              hd: "text-center",
                                              tl: {
                                                hd: tab === /* Connection */2 ? "text-links" : "text-gray-medium",
                                                tl: /* [] */0
                                              }
                                            }),
                                        children: "Соединение с ОФД"
                                      })
                                }) : null
                        ],
                        className: "bg-white px-2 lg:px-6 border-b border-gray-main w-full flex justify-between lg:justify-start lg:gap-4"
                      }),
                  tmp$1
                ],
                className: "w-full flex flex-col items-center"
              });
        } else {
          tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
        }
        return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
                    header: header,
                    children: tmp,
                    className: "bg-gray-pale"
                  });
      };
    };
  };
}

function KkmSettingsPage(Props) {
  return Curry._2(make(Props.org)(Props.id), Props.tab, Props.openMenu);
}

const make$1 = KkmSettingsPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
